import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const ROVO_EXTENSION_CLIENT_ID = client('rovo-extension');
